import { render, staticRenderFns } from "./bacground-config.vue?vue&type=template&id=47c05028&"
import script from "./bacground-config.vue?vue&type=script&lang=ts&"
export * from "./bacground-config.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports